import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {Area} from 'organization/Event/AreasProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {useState} from 'react'
import {DropResult} from 'react-beautiful-dnd'

export type SortMode = 'custom' | 'az' | 'za'

export function useSetAreaPositions(areas: Area[], sortMode: SortMode) {
  const {client} = useOrganization()
  const {event} = useEvent()
  const [orderedAreas, setOrderedAreas] = useState(areas)
  const [error, setError] = useState<string | null>(null)

  const displayedAreas = (() => {
    if (sortMode === 'az') {
      return [...orderedAreas].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {numeric: true}),
      )
    }

    if (sortMode === 'za') {
      return [...orderedAreas].sort((a, b) =>
        b.name.localeCompare(a.name, undefined, {numeric: true}),
      )
    }

    return orderedAreas
  })()

  const handleDrag = (result: DropResult) => {
    const {destination, source} = result

    if (!destination) {
      return
    }

    const moved = Array.from(orderedAreas)
    const [removed] = moved.splice(source.index, 1)
    moved.splice(destination.index, 0, removed)

    setOrderedAreas(moved)
    setError(null)

    const url = api(`/events/${event.id}/areas`)
    client.patch(url, {area_ids: moved.map((a) => a.id)}).catch((error) => {
      setOrderedAreas(orderedAreas)
      setError(error.message)
    })
  }

  return {
    areas: displayedAreas,
    handleDrag,
    error,
  }
}
